import { Component, type ReactNode } from 'react';

type GlobalErrorBoundaryProps = {
  children: ReactNode;
};

type GlobalErrorBoundaryState = {
  failed: boolean;
};

export function GlobalErrorFallback({ onRetry }: { onRetry: () => void }) {
  return (
    <main className="global-error" role="alert">
      <div className="global-error__mark" aria-hidden="true">
        <i />
        <i />
        <i />
      </div>
      <p className="eyebrow">Entangled Vega</p>
      <h1>The constellation lost its bearings.</h1>
      <p>
        An unexpected display error interrupted this view. Reload the static application to try
        again; no account or saved server state is involved.
      </p>
      <div className="global-error__actions">
        <button className="button button--gold" type="button" onClick={onRetry}>
          Reload constellation
        </button>
        <a className="button" href="/about">
          About
        </a>
        <a className="button" href="/privacy">
          Privacy &amp; Legal
        </a>
      </div>
    </main>
  );
}

export class GlobalErrorBoundary extends Component<
  GlobalErrorBoundaryProps,
  GlobalErrorBoundaryState
> {
  override state: GlobalErrorBoundaryState = { failed: false };

  static getDerivedStateFromError(): GlobalErrorBoundaryState {
    return { failed: true };
  }

  override render() {
    return this.state.failed ? (
      <GlobalErrorFallback onRetry={() => window.location.reload()} />
    ) : (
      this.props.children
    );
  }
}
